<!--
/**
* @name: Add.vue
* @description: 交易管理-运费模板设置新增页面
* @author: 杨波
* @create: 2020/08/17 14:06:58
* @update: 2020/08/17 14:06:58
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-form titleAlign="right" titleWidth="100px" contentWidth="100%">
      <y-form-item title="运费模板名称:" required>
        <k-input placeholder="请输入运费模板名称" block clearable v-model="editPara.name" :class="css.inputW"></k-input>
      </y-form-item>
      <y-form-item title="仓库限制:" required>
        <div>
          <k-radio v-model="editPara.isNormal" value="1">不限制</k-radio>
          <k-radio v-model="editPara.isNormal" value="0">限制</k-radio>
          <k-button v-if="editPara.isNormal == '0'" type="primary" size="mini" class="ml-1" @click="openWarehousePopupShow">选择</k-button>
        </div>
      </y-form-item>
      <y-form-item title="已选仓库:" required v-if="editPara.isNormal == '0'">
        <div :class="css.box">
          <span v-for="(item, index) in selectedWareSeatRows" :key="index">{{ item.seatName }} <i v-if="index + 1 != selectedWareSeatRows.length">，</i></span>
        </div>
      </y-form-item>
      <y-form-item title="运费设置:" required align="top">
        <k-table2 :hasIndex="false" :hasAction="false" :data="freightList" ref="table2" :columns="initColumns()" :hover="false" :row-data="baseRowData" max-height="calc(100vh - 120px)">
          <template slot="ordinary" slot-scope="{ row, index }">
            <k-input :class="css.input" type="number" min="0" block :ref="`ordinary_${index}`" no-style v-model="row.ordinary"></k-input>
          </template>
          <template slot="firstWeightPara" slot-scope="{ row, index }">
            <k-input :class="css.input" block :ref="`first_weight_${index}`" no-style v-model="row.firstFee"></k-input>
            <span :class="css.label"> 元/ </span>
            <k-input :class="css.input" block :ref="`first_fee_${index}`" no-style v-model="row.firstWeight"></k-input>
            <span :class="css.label"> KG</span>
          </template>
          <template slot="addWeightPara" slot-scope="{ row, index }">
            <k-input :class="css.input" block :ref="`add_weight_${index}`" no-style v-model="row.addFee"></k-input>
            <span :class="css.label"> 元/ </span>
            <k-input :class="css.input" block :ref="`add_fee_${index}`" no-style v-model="row.addWeight"></k-input>
            <span :class="css.label"> KG</span>
          </template>
          <template slot="select2" slot-scope="{ row }">
            <k-select2
              v-model="row.areaCodeList"
              :data="provinceList"
              text-field="areaName"
              key-field="areaCode"
              search-field="areaName"
              layer-width="auto"
              layerMinWidthEqual
              :nearby="false"
              placeholder="请选择地区"
              style="width: 95%;"
            >
            </k-select2>
          </template>
          <k-select slot="select" slot-scope="{ row }" v-model="row.providerCode" clearable block>
            <k-option v-for="item in shippingList" :key="item.providerCode" :value="item.providerCode" :label="item.providerName" :selected="item.providerCode == row.providerCode">{{
              item.providerName
            }}</k-option>
          </k-select>
        </k-table2>
        <k-button @click="onAddFreight" class="mt-1"> + 运费设置</k-button>
      </y-form-item>

      <y-form-item title="状态:" required>
        <div>
          <k-radio v-model="editPara.isDisabled" value="0">启用</k-radio>
          <k-radio v-model="editPara.isDisabled" value="1">停用</k-radio>
        </div>
      </y-form-item>
    </y-form>
    <k-popup bind="v-if" layout="header,body,close,mask" title="仓库选择" :show.sync="isShowWareHousePopup">
      <div style="width: 650px;">
        <k-table
          :data="wareSeatList"
          hasCheckbox
          checkboxKey="seatCode"
          :selectedRows.sync="selectedWareSeatRows"
          :selectedKeys.sync="editPara.wcodeList"
          :rightFixedNumber="1"
          :columns="initWareSeatColumns()"
        ></k-table>
      </div>
    </k-popup>
    <div slot="bottom" v-if="!isView">
      <k-button @click="onReset" v-if="isEdit">重置</k-button>
      <k-button @click="onCancel(true, false)" v-else>取消</k-button>
      <k-button type="primary" @click="onSave" :disabled="saveButtonStatus">保存</k-button>
    </div>
  </y-view>
</template>

<script>
import {
  NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_WARE_LIST,
  NESTLE_TRADE_BACK_SERVER_SHIPPING_TEMPLATE_DETAIL,
  NESTLE_TRADE_BACK_SERVER_SHIPPING_TEMPLATE_SAVE,
  NESTLE_TRADE_BACK_SERVER_SHIPPING_TEMPLATE_UPDATE,
  NESTLE_TRADE_BACK_SERVER_ST_PROVIDER_FEE_PROVIDER_LIST,
  NESTLE_TRADE_BACK_SERVER_ST_PROVIDER_FEE_CREATE,
  NESTLE_TRADE_BACK_SERVER_ST_PROVIDER_FEE_UPDATE,
  NESTLE_TRADE_BACK_SERVER_ST_PROVIDER_FEE_DELETE,
  NESTLE_TRADE_BACK_SERVER_BASE_DATA_AREA_PROVINCE,
} from "@/assets/modules/apiList";
const initEditPara = () => ({
  name: "",
  isDisabled: "",
  isNormal: "",
  wcodeList: [],
  providerFeeList: [],
});
const baseRowData = () => ({
  providerCode: "",
  ordinary: "",
  firstWeight: "",
  firstFee: "",
  addWeight: "",
  addFee: "",
  areaCodeList: [],
});
export default {
  data() {
    return {
      isShowWareHousePopup: false,
      selectedWareSeatRows: [],
      shippingList: [{}, {}],
      wareSeatList: [],
      provinceList: [],
      editPara: initEditPara(),
      isSaving: false,
      isView: false,
      isEdit: false,
      isLoading: false,
      baseRowData,
      originData: {},
      stId: "",
      freightList: Array.apply(null, { length: 1 }).map((t) => baseRowData()),
    };
  },
  watch: {
    "editPara.isNormal": {
      handler(newValue) {
        if (newValue == "1") {
          this.editPara.wcodeList = [];
          this.selectedWareSeatRows = [];
        }
      },
      immediate: true,
    },
  },
  methods: {
    initColumns() {
      return [
        {
          name: "物流公司",
          scopedSlots: "select",
          field: "providerCode",
          style: {
            width: 180,
            textAlign: "center",
          },
        },
        {
          field: "ordinary",
          name: "排序",
          style: {
            width: 70,
            padding: "1px",
            textAlign: "center",
          },
          scopedSlots: "ordinary",
        },
        {
          name: "地区选择",
          field: "areaCodeList",
          style: {
            width: 180,
            padding: "1px",
            textAlign: "center",
          },
          scopedSlots: "select2",
        },
        {
          name: "首重收费",
          field: "",
          style: {
            width: 180,
            textAlign: "center",
          },
          scopedSlots: "firstWeightPara",
        },
        {
          name: "续重收费",
          field: "",
          style: {
            width: 180,
            textAlign: "center",
          },
          scopedSlots: "addWeightPara",
        },
        {
          name: "操作",
          field: "",
          style: {
            width: 100,
            textAlign: "center",
          },
          customRender: (row) => {
            const deleteButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onDelete(row);
                }}
              >
                删除
              </a>
            );
            const saveButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onEditFreight(row);
                }}
              >
                保存
              </a>
            );
            if (this.isEdit) {
              return (
                <div>
                  {deleteButton}&#12288;{saveButton}
                </div>
              );
            }
          },
        },
      ];
    },
    initWareSeatColumns() {
      return [
        {
          name: "仓库名称",
          field: "seatName",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "仓库编码",
          field: "seatCode",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
      ];
    },
    openWarehousePopupShow() {
      this.getWareSeatList();
    },
    onCancel(isClose, isRefresh) {
      // 关闭弹出标签
      this.$controller.open(
        {
          name: "freightManagement",
          query: {
            refresh: isRefresh ? new Date() - 0 : 0,
          },
        },
        isClose ? this.$root.$router.currentRoute.name : undefined
      );
    },
    onReset() {
      this.editPara = JSON.parse(JSON.stringify(this.originData));
    },
    onEditFreight(obj) {
      if (!obj.stId) {
        obj.stId = this.stId;
      }
      const { tip } = this.$root;
      let para = JSON.parse(JSON.stringify(obj));
      this.$fetch({
        api: obj.id ? NESTLE_TRADE_BACK_SERVER_ST_PROVIDER_FEE_UPDATE : NESTLE_TRADE_BACK_SERVER_ST_PROVIDER_FEE_CREATE,
        para,
      }).then((res) => {
        tip("保存成功");
      });
    },
    onSave() {
      const { tip } = this.$root;
      if (this.isSaving) {
        return;
      }
      if (!this.isEdit) {
        let freightList = this.freightList;
        for (let i = 0; i < freightList.length; i++) {
          freightList[i].isAllArea = freightList[i].areaCodeList.length === this.provinceList.length ? 1 : 0;
          if (freightList[i].isAllArea == "1") {
            delete freightList[i].areaCodeList;
          }
        }
        this.editPara.providerFeeList = freightList;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      this.isSaving = true;
      this.isLoading = false;
      this.$fetch({
        api: this.isEdit ? NESTLE_TRADE_BACK_SERVER_SHIPPING_TEMPLATE_UPDATE : NESTLE_TRADE_BACK_SERVER_SHIPPING_TEMPLATE_SAVE,
        para,
      })
        .then((res) => {
          this.isSaving = false;
          this.isLoading = false;
          tip("操作成功");
          this.onCancel(true, true);
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },
    getProvinceList() {
      this.$fetch({
        api: NESTLE_TRADE_BACK_SERVER_BASE_DATA_AREA_PROVINCE,
        para: {},
      }).then((res) => {
        this.provinceList = res;
      });
    },
    getWareSeatList() {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_BASE_DATA_WARE_LIST,
        para: {},
      }).then((res) => {
        this.wareSeatList = res || [];
        this.isLoading = false;
        this.isShowWareHousePopup = true;
      });
    },
    getShippingList() {
      this.$fetch({
        api: NESTLE_TRADE_BACK_SERVER_ST_PROVIDER_FEE_PROVIDER_LIST,
        para: {},
      }).then((res) => {
        this.shippingList = res;
      });
    },
    getFreightDetail(id) {
      this.$fetch({
        api: NESTLE_TRADE_BACK_SERVER_SHIPPING_TEMPLATE_DETAIL,
        para: { id },
      })
        .then((res) => {
          this.originData = JSON.parse(JSON.stringify(res));
          this.editPara = res;
          let wcodeList = [];
          let selectedWareSeatRows = [];
          for (let i = 0; i < this.editPara.wcodeList.length; i++) {
            wcodeList.push(this.editPara.wcodeList[i].code);
            this.editPara.wcodeList[i].seatName = this.editPara.wcodeList[i].name;
            selectedWareSeatRows.push(this.editPara.wcodeList[i]);
          }
          this.editPara.wcodeList = wcodeList;
          this.selectedWareSeatRows = selectedWareSeatRows;
          this.editPara.isNormal = this.editPara.wcodeList && this.editPara.wcodeList.length > 0 ? "0" : "1";
          this.freightList = this.editPara.providerFeeList;
          for (let i = 0; i < this.freightList.length; i++) {
            this.freightList[i].stId = id;
            delete this.freightList[i].providerInfo;
            if (this.freightList[i].areaList && this.freightList[i].areaList.length > 0) {
              let temp = [];
              for (let j = 0; j < this.freightList[i].areaList.length; j++) {
                temp.push(this.freightList[i].areaList[j].areaCode);
              }
              this.freightList[i].areaCodeList = temp;
            }
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onAddFreight() {
      let array = Array.apply(null, { length: 1 }).map((t) => baseRowData());
      this.freightList = this.freightList.concat(array);
    },
    onDelete(row) {
      let { id } = row;
      this.$dialog({
        title: "提示",
        content: `是否确认删除该运费信息？`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_TRADE_BACK_SERVER_ST_PROVIDER_FEE_DELETE,
            para: { id },
          })
            .then(() => {
              this.isLoading = false;
              for (let i = 0; i < this.freightList.length; i++) {
                if (id == this.freightList[i].id) {
                  this.freightList.splice(i, 1);
                  break;
                }
              }
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
  },
  created() {
    this.getShippingList();
    this.getProvinceList();
    const { id, edit, view } = this.$route.query;
    if (id) {
      if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else if (view) {
        this.isEdit = false;
        this.isView = true;
      } else {
        this.isEdit = false;
        this.isView = false;
      }
      this.stId = id;
      this.getFreightDetail(id);
    } else {
      this.isEdit = false;
      this.isView = false;
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { id, edit, view } = to.query;
    this.editPara = initEditPara();
    this.freightList = Array.apply(null, { length: 1 }).map((t) => baseRowData());
    if (id) {
      if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else if (view) {
        this.isEdit = false;
        this.isView = true;
      } else {
        this.isEdit = false;
        this.isView = false;
      }
      this.stId = id;
      this.getFreightDetail(id);
    } else {
      this.isEdit = false;
      this.isView = false;
    }
    next();
  },
};
</script>

<style lang="postcss" module="css">
.box {
  width: 400px !important;
  min-height: 125px;
  padding: 10px;
  border: 1px solid #f0f2f5;
}
.inputW {
  width: 400px !important;
}
.input {
  width: 60px !important;
  display: inline-block !important;
  border: 1px solid #dcdfe6;
}
.label {
  color: #999 !important;
}
</style>
